import React, { useMemo } from 'react'

import { ComboBox, ComboBoxChange, ComboBoxOption } from 'components/ComboBox'

import { useCompanyDetail } from '../../../hooks/useCompanyDetail'

import { sanitizeVehicleNumber } from './vehicleNumberUtils'

type Props = {
  id?: string
  tenantId: string | null
  warehouseId: string | null
  driverCompanyId: string | null
  value: string
  onChange: (next: ComboBoxChange) => void
  disabled?: boolean
}

export const VehicleNumberComboBox: React.FC<Props> = ({
  id,
  tenantId,
  warehouseId,
  driverCompanyId,
  value,
  onChange,
  disabled,
}) => {
  const { companyDetail, isLoading } = useCompanyDetail({
    tenantId,
    warehouseId,
    companyId: driverCompanyId,
    type: 'driver',
  })

  const options = useMemo<ComboBoxOption[]>(
    () =>
      (companyDetail?.vehicles ?? [])
        .filter((v) => v.simpleCarNumber)
        .map((v) => ({
          label: v.simpleCarNumber as string,
          value: v.simpleCarNumber as string,
        })),
    [companyDetail]
  )

  const handleChange = (next: ComboBoxChange) => {
    onChange({ label: sanitizeVehicleNumber(next.label), value: next.value })
  }

  return (
    <ComboBox
      id={id}
      options={options}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      isLoading={isLoading}
      inputMode="numeric"
    />
  )
}
